"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translates = l.Translator.translate;
var AdupToolTipModel = /** @class */ (function () {
    function AdupToolTipModel() {
    }
    return AdupToolTipModel;
}());
var AdupToolTip = /** @class */ (function (_super) {
    __extends(AdupToolTip, _super);
    function AdupToolTip(props) {
        return _super.call(this, props) || this;
    }
    AdupToolTip.prototype.render = function () {
        return (React.createElement("div", { className: "dow-adup-ToolTip" },
            React.createElement("div", { className: "dow-tip-content text-left" },
                React.createElement("p", null, this.props.content)),
            React.createElement("div", { className: "dow-tip-iconbox" },
                React.createElement("span", { className: "icon-l-down dow-arrow-icon" }),
                React.createElement("span", { className: "icon-l-down dow-arrow-icon2" }))));
    };
    return AdupToolTip;
}(React.Component));
exports.AdupToolTip = AdupToolTip;
